import React from 'react';
import { IconProps } from '.';

const SvgBell = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M4.25 16.25V9.861C4.25 5.644 7.734 2.25 12 2.25s7.75 3.394 7.75 7.611v6.389H21v1.5h-5.25V18a3.75 3.75 0 1 1-7.5 0v-.25H3v-1.5h1.25Zm1.5-6.389c0-3.36 2.784-6.111 6.25-6.111s6.25 2.75 6.25 6.111v6.389H5.75V9.861Zm4 7.889V18a2.25 2.25 0 0 0 4.5 0v-.25h-4.5Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgBell;
